import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { baseURL } from "../Constant";
export const DipaSlice = createSlice({
 name: "dipa",
 initialState: {
  error: false,

  mailDataNudge: "",
  isDipaLoadedNudge: false,
  mailDataLaunch: "",
  isDipaLoadedLaunch: false,
  programDetails: [],
 },
 reducers: {
  setMailNudge: (state, { payload }) => {
   state.mailDataNudge = payload;
   state.isDipaLoadedNudge = true;
  },
  setMailLaunch: (state, { payload }) => {
   state.mailDataLaunch = payload;
   state.isDipaLoadedLaunch = true;
  },

  setProgramDetails: (state, { payload }) => {
   state.programDetails = payload;
  },
  setError: (state) => {
   state.error = true;
  },

  setMailLoadNudge: (state) => {
   state.isDipaLoadedNudge = false;
  },

  setMailLoadLaunch: (state) => {
   state.isDipaLoadedLaunch = false;
  },
 },
});

// Action creators are generated for each case reducer function
export const {
 setError,
 setProgramDetails,
 setMailNudge,
 setMailLoadNudge,
 setMailLaunch,
 setMailLoadLaunch,
} = DipaSlice.actions;

export default DipaSlice.reducer;

export function handleGenerateDipaNudge(values) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/dipaTeaser/fetchResponse`, { values })
   .then((response) => {
    // then print response status
    dispatch(setMailNudge(response.data));
   })
   .catch((err) => {
    // then print response status
    // console.error("fetch fail", err);
   });
 };
}
export function handleGenerateDipaNudgeNewContent(values) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/dipaTeaserNewContent/fetchResponse`, { values })
   .then((response) => {
    // then print response status
    dispatch(setMailNudge(response.data));
   })
   .catch((err) => {
    // then print response status
    // console.error("fetch fail", err);
   });
 };
}

export function handleDipaNudgeLoading() {
 return (dispatch) => {
  dispatch(setMailLoadNudge());
 };
}

export function handleGenerateDipaLaunch(values) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/dipaLaunch/fetchResponse`, { values })
   .then((response) => {
    // then print response status
    dispatch(setMailLaunch(response.data));
   })
   .catch((err) => {
    // then print response status
    // console.error("fetch fail", err);
   });
 };
}

export function handleGenerateDipaLaunchNewContent(values) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/dipaLaunchNewContent/fetchResponse`, { values })
   .then((response) => {
    // then print response status
    dispatch(setMailLaunch(response.data));
   })
   .catch((err) => {
    // then print response status
    // console.error("fetch fail", err);
   });
 };
}

export function handleDipaLaunchLoading() {
 return (dispatch) => {
  dispatch(setMailLoadLaunch());
 };
}

export function handleFetchProgramNames(val, categoryName) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/fetchProgramData`, { val, categoryName })
   .then((response) => {
    // then print response status
    dispatch(setProgramDetails(response.data));
   })
   .catch((err) => {
    // then print response status
    // console.error("fetch fail", err);
   });
 };
}
